import { ACCENT_SCHEMES } from "@/modules/user-settings/_constants/themes";
import { AccentScheme } from "@/store/user-config-store";
import { isDev, isDevStage } from "./configuration";

export enum AppEnvironment {
  Local = "local",
  Dev = "dev",
  Prod = "prod",
}

interface AppEnvironmentBranding {
  label: string;
  color: string;
}

function getAccentSchemeDarkColor(accentScheme: AccentScheme): string {
  const definition = ACCENT_SCHEMES.find((scheme) => scheme.scheme === accentScheme) ?? ACCENT_SCHEMES[0];
  return definition.primaryColorDark ?? definition.primaryColor;
}

const APP_ENVIRONMENT_BRANDING: Record<AppEnvironment, AppEnvironmentBranding> = {
  [AppEnvironment.Local]: { label: "LOCAL", color: getAccentSchemeDarkColor(AccentScheme.Amber) },
  [AppEnvironment.Dev]: { label: "DEV", color: getAccentSchemeDarkColor(AccentScheme.Ocean) },
  [AppEnvironment.Prod]: { label: "AlphaNET", color: getAccentSchemeDarkColor(AccentScheme.Classic) },
};

export function getAppEnvironment(): AppEnvironment {
  if (isDev && isDevStage) {
    return AppEnvironment.Local;
  }
  if (!isDev && isDevStage) {
    return AppEnvironment.Dev;
  }
  return AppEnvironment.Prod;
}

export function getAppEnvironmentBranding(): AppEnvironmentBranding {
  return APP_ENVIRONMENT_BRANDING[getAppEnvironment()];
}
